import { reaction } from 'mobx';
import { AnalyticsStore } from '../AnalyticsStore';
import { MraidStore } from '../MraidStore';

interface UserScrollHandlerProps {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;
}

export class UserScrollHandler {
  analyticsStore: AnalyticsStore;
  mraidStore: MraidStore;

  constructor({ analyticsStore, mraidStore }: UserScrollHandlerProps) {
    this.analyticsStore = analyticsStore;
    this.mraidStore = mraidStore;
    this.mraidStore.isDefaultMinimized && this.handleDefaultMinimized();
    this.mraidStore.isAdBelowHeader && this.handleAdBelowHeader();
    this.mraidStore.isAdAboveHeader && this.handleAdAboveHeader();

    reaction(
      () => this.mraidStore.currentMraidState,
      state => {
        state === 'resized' && this.handleResized();
        state === 'default' && this.handleDefault();
      }
    );
  }

  handleDefaultMinimized() {
    this.analyticsStore.sendCreativeTrack('header_minimized_default');
  }

  handleAdBelowHeader() {
    this.analyticsStore.sendCreativeTrack('header_ad_below_header');
  }

  handleAdAboveHeader() {
    this.analyticsStore.sendCreativeTrack('header_ad_above_header');
  }

  handleResized() {
    this.analyticsStore.sendCreativeTrack('header_minimized');
  }

  handleDefault() {
    this.analyticsStore.sendCreativeTrack('header_optimized');
  }
}
